import React from 'react';
import { clearFeedback } from '../../../store/actions/feedback.actions';
import ConnectedStateModal from '../Modals/ConnectedStateModal';
import { useDispatch, useSelector } from 'react-redux';
import { getFeedback } from '../../../store/selectors/feedback.selectors';

const Feedback = () => {
  const { message, isOpen, ...rest } = useSelector(getFeedback);
  const dispatch = useDispatch();

  const closeFeedback = () => dispatch(clearFeedback());

  const onCloseAction = () => {
    if (rest.modal) {
      rest.modal.onCloseAction && rest.modal.onCloseAction();
      return closeFeedback();
    }
  };

  if (!isOpen) return null;
  if (rest.modal) {
    const { modal } = rest;
    return (
      <ConnectedStateModal
        title={modal.title}
        isOpen={true}
        actionButton={modal.actionButton}
        onCloseAction={onCloseAction}
      >
        {message}
      </ConnectedStateModal>
    );
  }
  return;
};

export default Feedback;
